import {
    Heading, Stack, Text,
    Divider,
    Flex,
    VStack,
    Link
} from '@chakra-ui/react'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { colors } from '../../../ui-kit'
import { BaseLayout } from '..'
import UserDetails from '../../components/Profile/UserDetails'
import { MainContentHeadingBox, MainContentWrapper } from '../Base/MainContent'

const codeBlockStyles = {
    backgroundColor: '#193055',
    padding: 30,
    lineHeight: '20px',
    fontSize: 14,
    marginRight: '40px',
}

const AWSManagedLayout = (): React.ReactElement => {
    const { t } = useTranslation()

    return (
        <BaseLayout>
            <MainContentHeadingBox>
                <Stack direction={['column']} spacing={1}>
                    <Heading
                        as="h5"
                        size="md"
                        fontWeight="600"
                        color={colors.appDarkIndigo}
                    >
                        {t('billing_center', 'Billing center')}
                    </Heading>
                </Stack>
            </MainContentHeadingBox>
            <MainContentWrapper>
                <Flex direction="column" align="center" justify="center">
                    <Trans t={t} i18nKey="custom_plan_info">
                        <VStack>
                            <Text
                                marginTop="1.25em"
                                fontSize="1em"
                                fontWeight="semibold"
                                color="appBattleshipGrey"
                            >
                                Your subscription is managed through AWS Marketplace. Please go to the AWS Marketplace listing for cancellation or any other change. Any changes in your subscription can take up to an hour to reflect here.
                            </Text>
                        </VStack>
                    </Trans>
                </Flex>
            </MainContentWrapper>
        </BaseLayout>
    )
}

export default AWSManagedLayout
